/* eslint-disable react-hooks/exhaustive-deps */
/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-06-30 18:01:19
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-09 14:54:08
 */
import { unwrapResult } from "@reduxjs/toolkit";
import { Radio } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../app/store";
import { CirclePieCharts } from "../../components/CirclePieCharts";
import styles from "./ProportionDataAnaylse.module.css";
import { getProvinceDataAnaylseData } from "./ProvinceDataAnaylseSlice";

export const ProvinceProportionAnaylse = () => {
  const [time, setTime] = useState<any>();

  const [medicalData, setMedicalData] = useState<any>([]);

  const [cautionData, setCautionData] = useState<any>([]);

  const [handleData, setHandleData] = useState<any>([]);

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(getProvinceDataAnaylseData(time))
      .then(unwrapResult)
      .then((res) => {
        setMedicalData(
          res.map((v) => {
            return {
              name: v.urbanName,
              value: v.medicalTotal || undefined,
            };
          })
        );
        setCautionData(
          res.map((v) => {
            return {
              name: v.urbanName,
              value: v.cautionTotal || undefined,
            };
          })
        );
        setHandleData(
          res.map((v) => {
            return {
              name: v.urbanName,
              value: v.handleTotal || undefined,
            };
          })
        );
        console.log(res);
      });
  }, [time]);

  useEffect(() => {
    return () => {
      setMedicalData([]);
      setCautionData([]);
      setHandleData([]);
    };
  }, [time]);

  return (
    <div className={styles.proportion}>
      <div className={styles.dataSelect}>
        <Radio.Group
          defaultValue={time}
          onChange={(e: any) => {
            setTime(e.target.value);
          }}
          optionType="button"
          buttonStyle="solid"
        >
          <Radio.Button value={0}>近七天</Radio.Button>
          <Radio.Button value={1}>近30天</Radio.Button>
          <Radio.Button value={2}>近一年</Radio.Button>
          <Radio.Button>全部</Radio.Button>
        </Radio.Group>
      </div>
      <div className={styles.piebox}>
        <div className={styles.anaylseCard}>
          <CirclePieCharts
            pieTitle="浙江省各市诊疗数据占比分析"
            pieData={medicalData}
            style={{ height: "100%", padding: "10px" }}
          />
        </div>
        <div className={styles.anaylseCard}>
          <CirclePieCharts
            pieTitle="浙江省各市预警数据占比分析"
            pieData={cautionData}
            style={{ height: "100%", padding: "10px" }}
          />
        </div>
        <div className={styles.anaylseCard}>
          <CirclePieCharts
            pieTitle="浙江省各市处置数据占比分析"
            pieData={handleData}
            style={{ height: "100%", padding: "10px" }}
          />
        </div>
      </div>
    </div>
  );
};
